module.exports = __webpack_public_path__ + "static/EventsMEnabling-cdea637583863f863a2c255d6345a920.png";